module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/edeka_genussmomente_foodporn_garnelen.jpg";